module.exports = __webpack_public_path__ + "static/media/s1.0a3ba114.jpg";